'use client';

import { useEffect, useState } from 'react';
import Footer from './Footer';
import { FooterLogoText, FooterSections } from '@/types/types';

interface FooterWrapperProps {
  footerLogoData: FooterLogoText;
  footerSectionsData: FooterSections;
}

export default function FooterWrapper({
  footerLogoData,
  footerSectionsData,
}: FooterWrapperProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only show footer after Builder content is loaded
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 500); // Increased delay to ensure Builder content is loaded

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        visibility: isVisible ? 'visible' : 'hidden',
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 500ms ease-in-out',
        position: 'relative',
        width: '100%',
      }}
    >
      <Footer
        footerLogoData={footerLogoData}
        footerSectionsData={footerSectionsData}
      />
    </div>
  );
}
